import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=7799b1ba&scoped=true&"
import script from "./MyCollection.vue?vue&type=script&lang=js&"
export * from "./MyCollection.vue?vue&type=script&lang=js&"
import style0 from "./MyCollection.vue?vue&type=style&index=0&id=7799b1ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799b1ba",
  null
  
)

export default component.exports